/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Measure/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Measure({
  children,
  viewPath = "/DesignSystem/Measure",
  measureRef,
  height = 0,
  width = "100%",
  overflowX = "hidden",
  overflowy = "hidden",
  alignItems = "center",
  justifyContent = "center",
  position = "relative"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Measure.Vertical"
  data-view-path={viewPath}
 ref={measureRef}
 overflowy={overflowy}
 style={{'--h-1-Z20ckwo': typeof height === 'number' ? `${height}px` : height,'--w-2-Z20ckwo': typeof width === 'number' ? `${width}px` : width,'--ox-3-Z20ckwo': overflowX,'--ai-4-Z20ckwo': alignItems,'--jc-5-Z20ckwo': justifyContent,'--p-6-Z20ckwo': position}}
 className={`views-block ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</div>
</React.Fragment>)
}